export default __webpack_public_path__ + "static/synap-f2cb8fee95cda1e198daf563754a765c.svg";